import axios from 'axios'
import { ApiResponse } from '../types/response'
import { message } from 'ant-design-vue'
import { getPharmaAiToken, redirectToSso } from './auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // API 基础路径
  timeout: 10000, // 请求超时时间
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getPharmaAiToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    
    // 将响应数据转换为 ApiResponse 对象
    const apiResponse = new ApiResponse({
      data: res.data,
      errmsg: res.errmsg,
      errno: res.errno,
      status: res.status
    })
    
    // 如果 errno 不为 0，表示请求失败
    if (!apiResponse.isSuccess()) {
      // 显示错误消息
      const errorMsg = apiResponse.errmsg || '请求失败'
      message.error(errorMsg)
      return Promise.reject(new Error(errorMsg))
    }
    
    // 返回 ApiResponse 对象
    return apiResponse
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    let errorMessage = '请求失败'
    
    if (error.response) {
      // 服务器返回了错误状态码
      const { status, data } = error.response
      
      switch (status) {
        case 400:
          errorMessage = '请求参数错误'
          break
        case 401:
          errorMessage = '未授权，请重新登录'
          // router.push('/login')
          break
        case 403:
          errorMessage = '拒绝访问'
          redirectToSso()
          break
        case 404:
          errorMessage = '请求的资源不存在'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        case 502:
          errorMessage = '网关错误'
          break
        case 503:
          errorMessage = '服务不可用'
          break
        case 504:
          errorMessage = '网关超时'
          break
        default:
          errorMessage = data?.errmsg || `请求失败 (${status})`
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      errorMessage = '网络错误，请检查网络连接'
    } else {
      // 发送请求时出了点问题
      errorMessage = error.message || '请求失败'
    }
    
    message.error(errorMessage)
    return Promise.reject(error)
  }
)

export default service

